import { Textarea } from "@chakra-ui/react";
import { ReactNode } from "react";
import { FieldComponentProps } from "./types";

export function FieldTextarea(props: FieldComponentProps): ReactNode {
  return (
    <Textarea
      id={props.id}
      name={props.label}
      onChange={(event) => {
        props.updateValue({ label: props.label, value: event.target.value });
      }}
      value={props.value}
    />
  );
}
